'use client';

import type { FC } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Grid2, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Image from 'next/image';
import 'swiper/css';
import 'swiper/css/grid';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import './index.css';
import { useTranslations } from 'next-intl';
import UKImage from '/public/images/country/UK.svg';
import Mexico from '/public/images/country/Mexico.svg';
import Indonesia from '/public/images/country/Indonesia.svg';
import USA from '/public/images/country/USA.svg';
import Korea from '/public/images/country/Korea.svg';
import Singapore from '/public/images/country/Singapore.svg';
import China from '/public/images/country/China.svg';
import Japan from '/public/images/country/Japan.svg';
import { Grid, Autoplay, Pagination, Navigation } from 'swiper/modules';
import SwiperText from './SwpierText';

const slidesFrontList = [
  {
    src: UKImage,
    value: 'United Kingdom',
    alt: 'UK swiper slide',
  },
  {
    src: Mexico,
    value: 'Mexico',
    alt: 'Mexico swiper slide',
  },
];

const slidesList = [
  {
    src: Indonesia,
    value: 'Indonesia',
    alt: 'Indonesia swiper slide',
  },
  {
    src: USA,
    value: 'USA',
    alt: 'USA swiper slide',
  },
  {
    src: Korea,
    value: 'Korea',
    alt: 'Korea swiper slide',
  },
  {
    src: Singapore,
    value: 'Singapore',
    alt: 'Singapore swiper slide',
  },
  {
    src: China,
    value: 'China',
    alt: 'China swiper slide',
  },
  {
    src: Japan,
    value: 'Japan',
    alt: 'Japan swiper slide',
  },
];

const CountrySwiper: FC = () => {
  const t = useTranslations('Home.countrySwiper');
  const theme = useTheme();

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const SlideHeight = '400px';

  const isXs = useMediaQuery(theme.breakpoints.up('xs'), {
    defaultMatches: true,
  });
  const isSm = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  });

  const isLg = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true,
  });

  let slidesToShow = 1;
  if (isXs) {
    slidesToShow = 1;
  }
  if (isSm) {
    slidesToShow = 3;
  }
  if (isMd) {
    slidesToShow = 4;
  }
  if (isLg) {
    slidesToShow = 5;
  }

  const sliderMaxWidth = '400px';

  return (
    <Box
      py={{
        xs: 4,
        md: 8,
      }}
      px={2}
    >
      <Grid2
        size={12}
        container
        data-aos={isMd ? 'fade-right' : 'fade-up'}
        data-aos-duration={600}
      >
        <Swiper
          initialSlide={0}
          direction="horizontal"
          slidesPerView={slidesToShow}
          spaceBetween={25}
          grid={{
            rows: 1,
          }}
          effect="fade"
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          grabCursor={true}
          pagination={false}
          navigation={false}
          modules={[Autoplay, Grid, Pagination, Navigation]}
          className="mySwiper"
        >
          {slidesFrontList.map((item) => (
            <SwiperSlide key={item.value}>
              <Box
                sx={{
                  height: SlideHeight, // 固定高度，确保图片和文本的高度一致
                  width: 'inherit',
                  borderRadius: '16px',
                  cursor: 'default',
                  maxWidth: sliderMaxWidth,
                  position: 'relative',
                }}
              >
                <Image
                  src={item.src}
                  alt={item.alt}
                  style={{
                    height: '100%', // 确保图片填满容器
                    width: '100%', // 图片宽度填满
                    objectFit: 'cover', // 防止图片变形
                    borderRadius: 'inherit',
                  }}
                />
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: '20px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    whiteSpace: 'nowrap',
                    color: '#fff',
                    fontWeight: 700,
                    fontSize: '24px',
                  }}
                >
                  {item.value}
                </Box>
              </Box>
            </SwiperSlide>
          ))}
          <SwiperSlide key={'custom'} style={{ minWidth: '275px' }}>
            <Box
              sx={{
                height: SlideHeight, // 固定高度，与图片保持一致
                borderRadius: '16px',
                position: 'relative',
              }}
            >
              <SwiperText
                title={t('title')}
                desciption={t('description')}
                boxSx={{
                  backgroundColor: '#DBEAFE',
                  color: '#000',
                  height: '100%', // 填充整个容器的高度
                  cursor: 'pointer',
                  display: 'flex',
                  flexDirection: 'column',
                  position: 'relative',
                }}
                desciptionSx={{
                  color: '#333',
                }}
                iconSx={{
                  color: 'inherit',
                  fill: 'currentcolor',
                  fontSize: '42px',
                }}
                handleClick={() =>
                  window.open('https://app.sailglobal.com/en/login', '_blank')
                }
              />
            </Box>
          </SwiperSlide>
          {slidesList.map((item) => (
            <SwiperSlide key={item.value}>
              <Box
                sx={{
                  height: SlideHeight, // 固定高度，与图片保持一致
                  width: 'inherit',
                  borderRadius: '16px',
                  cursor: 'default',
                  maxWidth: sliderMaxWidth,
                  position: 'relative',
                }}
              >
                <Image
                  src={item.src}
                  alt={item.alt}
                  style={{
                    height: '100%', // 确保图片填满容器
                    width: '100%', // 图片宽度填满
                    objectFit: 'cover', // 防止图片变形
                    borderRadius: 'inherit',
                  }}
                />
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: '20px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    whiteSpace: 'nowrap',
                    color: '#fff',
                    fontWeight: 700,
                    fontSize: '24px',
                  }}
                >
                  {item.value}
                </Box>
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
      </Grid2>
    </Box>
  );
};

export default CountrySwiper;
